import React, {useEffect, useState} from "react";
import {blobToBase64} from "../utils";
import axios from "axios";
import {useSelector} from "react-redux";
import useTranslation from "../../virtual_congress/effects/use_translation";

const PhotoScissorsEditor = ({
                               imageBlob,
                               onFinished,
                               photoBoothConfig,
                               selectedFrame,
                               onResetClicked,
                               onBackClicked,
                               translationHtmlContent,
                             }) => {
  const [dataUrl, setDataUrl] = useState()
  const [sending, setSending] = useState()
  const removeBackgroundUrl = useSelector(state => state.photo_booth.remove_background_url?.replace("@@photo_booth_config_id@@", photoBoothConfig.id))
  const t = useTranslation(translationHtmlContent)

  useEffect(() => {
    blobToBase64(imageBlob).then(du => {
      setDataUrl(du)
    })
  }, [])

  const onRemoveBackground = () => {
    setSending(true)
    const formData = new FormData();

    formData.append("image", imageBlob);

    axios.post(removeBackgroundUrl, formData, {responseType: 'blob'})
      .then((response) => {
        setSending(false)
        onFinished(response.data, true)
      })
      .catch((error) => {
        alert(error)
        setSending(false)
      })
  }

  const onContinueWithBackground = () => {
    onFinished(imageBlob, false)
  }

  return <div className={"photo-background-removal-container"}>
    <div className={"image-container"}>
      <img
        className={"ghost-image"}
        width={photoBoothConfig.target_image_width}
        height={photoBoothConfig.target_image_height}
      />
      <img
        className={"uploaded-image"}
        src={dataUrl}
        width={photoBoothConfig.target_image_width}
        height={photoBoothConfig.target_image_height}
      />
      {selectedFrame && <img
        className={"frame-image"}
        src={selectedFrame}
        width={photoBoothConfig.target_image_width}
        height={photoBoothConfig.target_image_height}
      />}
      {sending && t("photo_booth.photo_scissors.processing_overlay", {}, <></>)}
    </div>

    <div className={"button-container"}>
      <button
        disabled={sending}
        className={"photo-booth-button back-button"}
        onClick={onBackClicked}
        type={"button"}>
        {t("photo_booth.photo_scissors.back_button_html", {}, "Back")}
      </button>

      <button
        disabled={sending}
        className={"photo-booth-button back-button"}
        onClick={onResetClicked}
        type={"button"}>
        {t("photo_booth.photo_scissors.reset_button_html", {}, "Reset")}
      </button>

      <button
        disabled={sending}
        className={"photo-booth-button remove-background-button"}
        onClick={onRemoveBackground}
        type={"button"}>
        {t("photo_booth.photo_scissors.remove_background_button_html", {}, "Remove Background")}
      </button>

      <button
        disabled={sending}
        className={"photo-booth-button keep-background-button"}
        onClick={onContinueWithBackground}
        type={"button"}>
        {t("photo_booth.photo_scissors.continue_with_background_button_html", {}, "Continue With background")}
      </button>
    </div>
  </div>
}

export default PhotoScissorsEditor